

<!-- <div *ngIf="!isPrint" class="container pt-0 pb-0">
    <div class="row">
        <div class="col-12 text-end">
            <button class="btn btn-secondary ms-3 text-white" (click)="printPage();"><i class="bi bi-printer text-white"></i></button>

            <button class="btn btn-secondary ms-3 text-white" (click)="downloadPdf();"><i class="bi bi-file-earmark-pdf text-white"></i></button>

        </div>
    </div>
</div> -->


<div  id="exportpdf">
<div class="container">

    <div class="row">
        <div class="col-12 text-center">
            <br><br><br><br>
            <h3><b><u>List Quotation</u></b></h3>
        </div>

        <div class="col-12"><br><br>
        </div>

        <div class="col-3 text-end">
        <h5>Penawaran Untuk:</h5>
        </div>
        <div class="col-9">
        </div>

        <div class="col-3 text-end">
            <div *ngIf="companyBase64">
                <img src="{{companyBase64}}" style="max-width: 80; max-height:80px;">
            </div>
            <div *ngIf="!companyBase64">
                <svg width="120" height="120">
                    <rect width="120" height="120" 
                    style="fill:rgb(217,217,217);stroke-width:0;stroke:rgb(0,0,0)" />
                  Sorry, your browser does not support inline SVG.
                </svg>
            </div>
            <!-- <svg width="120" height="120">
                <rect width="120" height="120" 
                style="fill:rgb(217,217,217);stroke-width:0;stroke:rgb(0,0,0)" />
              Sorry, your browser does not support inline SVG.
            </svg> -->
        </div>
        <div class="col-4">
            <b>{{companyName}}</b>
            <b>{{DataQuotation?.procurementDetailAddress?.companyName}}</b><br>
  


            <font [innerHTML]="companyAddress"></font>
            <br>

        </div>
        <div class="col-1">

        </div>
        <div class="col-4">
            No. Telepon : {{ (companyPhone) ? companyPhone :'-' }}<br>
            Email : {{ (companyEmail) ? companyEmail :'-' }}
        </div>

        <div class="col-12"><br></div>

        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    <b>Termin Pembayaran</b>
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{(DataRfq?.paymentTermRequestedInDays) ? DataRfq?.paymentTermRequestedInDays+' Days':'-'}}
                </div>
            </div>
        </div>
        <div class="col-2"></div>
        <!-- <div class="col-5 p-2">
            <div class="row g-0">
                <div class="col-12 ps-2 pe-2 text-end">
                    <b><u>RFQ Id : # {{formatDisplayId(DataRfq?.rfqDisplayId)}}</u></b>
                </div>
            </div>
            
        </div> -->
        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    <b>ID RFQ</b>
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                     <b># {{formatDisplayId(DataRfq?.rfqDisplayId)}}</b>
                </div>
            </div>
        </div>


        <div class="col-12 p-1"></div>

        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    <b>Mata Uang</b>
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{ DataRfq?.currency }}
                </div>
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    <b>Tanggal</b>
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{DataRfq?.createdDate | date:'d MMM y'}}
                </div>
            </div>
        </div>

        <div class="col-12 p-1"></div>

        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                   <b>No. Referensi Internal</b>
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    {{ (DataRfq?.procurementRefNumber)?DataRfq?.procurementRefNumber:'-' }}
                </div>
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
            <div class="row g-0">
                <div class="col-6 p-2">
                    <b>Permintaan ETA</b>
                </div>
                <div class="col-6 p-2" style="background-color: #f1f1f1;">
                    <font *ngIf="DataRfq?.etaRequested">{{DataRfq?.etaRequested | date:'d MMM y'}}</font>
                    <font *ngIf="!DataRfq?.etaRequested">-</font>
                </div>
            </div>
        </div>






        <div class="col-12 p-1"><br></div>

        <div class="col-5">
            <table class="table p-2">
                <tr>
                    <td style="background-color: #e8e8e8;color: #000000;"><p class="py-2 mb-0 text-center">
                        <b>Penawaran Sebagian</b>
                    </p></td>
                </tr>
                <tr>
                    <td style="border: solid 1px #f0f0f0;">

                      <table width="100%">
                        <tr>
                          <td width="45%">Penawaran Terendah</td>
                          <td width="5%">:</td>
                          <td class="text-end" width="50%">
                            {{DataRfq.currency}} {{DataLowestHighestPrice?.partialLowest| number}}
                          </td>
                        </tr>
                        <tr>
                          <td>Penawaran Tertinggi</td>
                          <td>:</td>
                          <td class="text-end" width="25%">{{DataRfq.currency}} {{DataLowestHighestPrice?.partialHighest|
                        number}}</td>
                        </tr>
                        <tr>
                          <td>Selisih Harga</td>
                          <td>:</td>
                          <td class="text-end" width="25%">{{DataRfq.currency}} {{
                        calculate(DataLowestHighestPrice?.partialHighest,DataLowestHighestPrice?.partialLowest,'-')
                        | number}}</td>
                        </tr>
                      </table>

                    </td>
                </tr>
            </table>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
            <table class="table p-2">
                <tr>
                    <td style="background-color: #e8e8e8;color: #000000;"><p class="py-2 mb-0 text-center">
                      <b>Penawaran Penuh</b>
                    </p></td>
                </tr>
                <tr>
                    <td style="border: solid 1px #f0f0f0;">

                      <table width="100%">
                        <tr>
                          <td width="45%">Penawaran Terendah</td>
                          <td width="5%">:</td>
                          <td class="text-end" width="50%">{{DataRfq.currency}} {{DataLowestHighestPrice?.fullQuoteLowest|
                        number}}</td>
                        </tr>
                        <tr>
                          <td>Penawaran Tertinggi</td>
                          <td>:</td>
                          <td class="text-end" width="25%">{{DataRfq.currency}} {{DataLowestHighestPrice?.fullQuoteHighest|
                        number}}</td>
                        </tr>
                        <tr>
                          <td>Selisih Harga</td>
                          <td>:</td>
                          <td class="text-end" width="25%">{{DataRfq.currency}} {{
                        calculate(DataLowestHighestPrice?.fullQuoteHighest,DataLowestHighestPrice?.fullQuoteLowest,'-')
                        | number}}</td>
                        </tr>
                      </table>

                    </td>
                </tr>
            </table>
        </div>

        <div class="col-12"><br><hr><br></div>

        <div class="col-12">
            <table class="table p-2" style="background-color: #e8e8e8;color: #000000;">
                <tr>
                    <td>
                      <p class="p-2 mb-0">
                        <b>Daftar permintaan produk: Penawaran Sebagian</b>
                      </p>
                    </td>
                    <td class="text-end">
                      <p class="p-2 mb-0">
                        <b>Total Terpilih: {{DataRfq.currency}} {{ totalselected | number }}</b>
                      </p>                      
                    </td>
                </tr>
            </table>
        </div>


        <div class="col-12"><br></div>
    
        <div class="col-12"  *ngFor="let item of datagetRfqItemListDataRfq?.quotedRfqItem; let i = index">
            <table class="table mb-0">
                <tr>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>#</b>
                    </th>
                    <th  style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Nomor SKU</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Merk Produk</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Deskripsi Produk</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Jumlah Diminta</b>
                    </th>
                </tr>

                <tr>
                  
                    <td style="border: solid 1px #f0f0f0;">{{ i+1 }}</td>
                    <td style="border: solid 1px #f0f0f0;">{{item.manufacturerSku ? item.manufacturerSku : '-'}}</td>
                    <td style="border: solid 1px #f0f0f0;">{{item.brand}}</td>
                    <td style="border: solid 1px #f0f0f0;">
                      
                                          <div class="">
                                            <!-- <p><b>Deskripsi Produk</b></p> -->
                                              <div style="white-space: normal;">
                                                <font *ngIf="!(divDetailspecLess(item.description).length>50)">{{ divDetailspecLess(item.description) }}</font>
              
                                                <div *ngIf="arrMoreLessDesc[i]=='less' && divDetailspecLess(item.description).length>50">
                                                  {{ divDetailspecLess(item.description) }}
                                                  <strong><span class="c1 pointer" (click)="MoreLessDesc(i,'more')">Read More</span></strong>
                                                </div>
                                                <div *ngIf="arrMoreLessDesc[i]=='more' && divDetailspecLess(item.description).length>50">
                                                  {{ divDetailspec(item.description) }}
                                                  <strong><span class="c1 pointer" (click)="MoreLessDesc(i,'less')">Read Less</span></strong>                   
                                                </div>
                                              </div>
                                          </div> 
                                          <!-- <div class="mb-3">
                                            <p><b>Label - Spesifikasi</b></p>
                                            <div [innerHTML]='divspec(item.description)'></div>
                                          </div>                        -->
                    </td>
                    <td style="border: solid 1px #f0f0f0;" class="text-end">{{item.qtyNeeded | number}} {{item.itemUnit }} </td>
                </tr>



            </table>


            <table class="table table-striped">
              <thead>
                <tr>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>#</b>
                    </th>
                    <th  style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Nama Vendor</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Jumlah Dipesan</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Jumlah Penawaran</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Harga</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Total</b>
                    </th>                    
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let vendor of item.vendorQuotationOfferData; let j = index" class="listdata vendor?.retract ? 'retractdiv':''}}" >
                  
                    <td style="border: solid 1px #f0f0f0;">{{ j+1 }}</td>
                    <td style="border: solid 1px #f0f0f0;">
                      
                    <div class="row g-0">
                      <div class="col-10">
                        {{ vendor.vendorName }} 
                      </div>
                      <div class="col-2 text-end">
                        <ng-container *ngIf="qtytooofferchanges[vendor.quotationItemId] > 0">
                           <i class="bi bi-check2"></i>
                        </ng-container>
                        
                      </div>
                    </div>
                    </td>
                    <td style="border: solid 1px #f0f0f0;" class="text-end">{{qtytooofferchanges[vendor.quotationItemId] | number}}</td>
                    <td style="border: solid 1px #f0f0f0;" class="text-end"> {{vendor.qtyOffered | number}}</td>
                    <td style="border: solid 1px #f0f0f0;" class="text-end">{{DataRfq.currency}} {{ vendor.offeredPrice | number }}</td>
                    <td style="border: solid 1px #f0f0f0;" class="text-end">{{DataRfq.currency}} {{ vendor.totalOffered | number }}</td>
                </tr>
              </tbody>
              <tfoot>
                  <tr>
                    <td colspan="2" class="text-end"><strong>Jumlah Dipilih : {{ item.totalSelectedQty | number }}</strong></td>
                    <td colspan="2" class="text-end"><strong>Penarawan Terendah : {{DataRfq.currency}} {{ item.bestOffer | number }}</strong></td>
                    <td colspan="2" class="text-end"><strong>Penawaran Dipilih : {{DataRfq.currency}} {{ item.totalSelectedOffer | number }}</strong></td>
                  </tr>                  
              </tfoot>
            </table>

            

        </div>

        <!--- penawaran penuh  -->

        <div class="col-12"><br><hr><br></div>

        <div class="col-12">
            <table class="table p-2" style="background-color: #e8e8e8;color: #000000;">
                <tr>
                    <td>
                      <p class="p-2 mb-0">
                        <b>Daftar permintaan produk: Penawaran Penuh</b>
                      </p>
                    </td>
                    <td class="text-end">
                      <p class="p-2 mb-0">
                        <b>Total Terpilih: {{DataRfq.currency}} {{DataCompleteOrderQuotationOffer | number}}</b>
                      </p>                      
                    </td>
                </tr>
            </table>
        </div>


        <div class="col-12"><br></div>
    
        <div class="col-12">

            <table class="table table-striped">
              <thead>
                <tr>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>#</b>
                    </th>
                    <th  style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Nomor SKU</b>
                    </th>
                    <th style="border: solid 1px #f0f0f0;background-color: #353535;color: #ffffff;">
                        <b>Total</b>
                    </th>                    
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let vendor of DataCompleteOrderQuotation; let j = index" class="listdata vendor?.retract ? 'retractdiv':''" >
                  
                    <td style="border: solid 1px #f0f0f0;">{{ j+1 }}</td>
                    <td style="border: solid 1px #f0f0f0;">
                      
                    <div class="row g-0">
                      <div class="col-10">
                        {{ vendor.vendorName }} 
                      </div>
                      <div class="col-2 text-end">
                        <ng-container *ngIf="vendor.isSelected">
                           <i class="bi bi-check2"></i>
                        </ng-container>
                        
                      </div>
                    </div>
                    </td>
                    <td style="border: solid 1px #f0f0f0;" class="text-end">{{DataRfq.currency}} {{vendor.totalQuotationPrice | number}}</td>
                </tr>
                                  <tr *ngIf="DataCompleteOrderQuotation?.length<1">
                                    <td colspan="3" class="text-center listdata" >
                                      There is no full quotation yet.
                                    </td>
                                  </tr>                
              </tbody>
              <tfoot>
                  <tr>
                    <td colspan="3" class="text-end"><strong>Penawaran Dipilih : {{DataRfq.currency}} {{DataCompleteOrderQuotationOffer | number}}</strong></td>
                  </tr>                  
              </tfoot>
            </table>

            

        </div>



        <div class="col-12">
            <br>
            <br>
            <!-- This document is submitted by (_________) on (__/__/____  __:__)
            <br> -->




            Dokumen ini dibuat oleh (Nama Pengguna Procurement) pada tanggal {{DataRfq?.createdDate  | date:'d MMM y'}}<br>
            <ng-container *ngIf="DataRfq?.state !== 'UNPUBLISHED'">
              Dokumen ini disetujui oleh (Nama Manager/Owner Procurement) pada tanggal {{DataRfq?.modifiedDate  | date:'d MMM y'}}
            </ng-container>            
            
            <br><br>
            ** QUOTATION {{DataRfq?.state}} **


            <br>
            <br>
            <br>
            <br><br>
        </div>
    </div>





</div>
</div>
























































